
import React from 'react';
import { Zap } from 'lucide-react';

interface PricingToggleProps {
  billingPeriod: 'monthly' | 'yearly';
  setBillingPeriod: (period: 'monthly' | 'yearly') => void;
}

const PricingToggle: React.FC<PricingToggleProps> = ({ 
  billingPeriod, 
  setBillingPeriod 
}) => {
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="inline-flex items-center p-1 rounded-full border-2 border-darkgray bg-white overflow-hidden shadow-sm">
        <button
          onClick={() => setBillingPeriod('monthly')}
          className={`relative px-6 py-2 rounded-full text-sm font-montserrat font-bold transition-all duration-300 ${
            billingPeriod === 'monthly' 
              ? 'bg-darkgray text-white'
              : 'bg-transparent text-darkgray/70 hover:bg-black/5'
          }`}
        >
          Månadsvis
        </button>
        
        <button
          onClick={() => setBillingPeriod('yearly')}
          className={`relative px-6 py-2 rounded-full text-sm font-montserrat font-bold transition-all duration-300 ${
            billingPeriod === 'yearly' 
              ? 'bg-darkgray text-white'
              : 'bg-transparent text-darkgray/70 hover:bg-black/5'
          }`}
        >
          Årsvis (spara 20%)*
        </button>
      </div>

      <div className="inline-flex items-center text-sm text-darkgray bg-yellow-300 px-4 py-2 rounded-full">
        <Zap className="h-4 w-4 mr-1.5 text-accent" />
        <span className="font-medium font-opensans">Spara 20% med årsabonnemang</span>
      </div>
    </div>
  );
};

export default PricingToggle;
